export function metaSetup(context = {}) {
  const { fbAppId, lang } = context;

  if (fbAppId) {
    document.querySelector('meta[property="fb:app_id"]').setAttribute('content', fbAppId);
  }

  if (lang) {
    const locale = lang.toLowerCase();
    document.documentElement.lang = locale;
    document.querySelector('meta[property="og:locale"]').setAttribute('content', locale);
  }
}
